import { useId } from "react";

import { Button, InfoModal } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  objectTypes,
  actionNames,
  useTracker,
  eventTypes,
} from "@newsela/snitch";
import assignmentPropTypes from "@/assignments/utils/assignmentPropTypes";
import { shareModalCss } from "./ShareAssignmentModal.style";

const propTypes = {
  children: PropTypes.node,
  shareModalProps: PropTypes.object,
  streamProperties: PropTypes.object,
  updatedAssignment: assignmentPropTypes,
};

const ShareAssignmentModal = ({
  children,
  shareModalProps,
  streamProperties,
  updatedAssignment,
}) => {
  const labelId = `ShareAssignmentModal${useId()}`;
  const { trackAction, getEventName } = useTracker();

  const handleCloseModalTracking = () => {
    trackAction({
      event_type: eventTypes.click,
      event_name: getEventName(
        objectTypes.assignment,
        null,
        actionNames.create,
      ),
      dimension_properties: {
        ...streamProperties,
        content_ids: updatedAssignment?.assignment_members?.map(
          (member) => member.content_id,
        ),
        description: "Close share assignment modal.",
      },
    });
  };

  const handleCloseModal = () => shareModalProps.closeModal();

  return (
    <InfoModal
      __cssFor={shareModalCss}
      eyebrow="Assignment successfully created!"
      labelId={labelId}
      onBackgroundClick={handleCloseModal}
      onClose={handleCloseModalTracking}
      onEsc={handleCloseModal}
      footer={
        <Button
          flavor={Button.flavors.primary}
          onClick={handleCloseModal}
          dataProps={{ "data-qa-selector": "share-assignment-modal-done" }}
        >
          Done
        </Button>
      }
      title="Share it with your class"
      {...shareModalProps}
    >
      {children}
    </InfoModal>
  );
};

ShareAssignmentModal.propTypes = propTypes;

export default ShareAssignmentModal;
